export const IS_SENTRY_ENABLED = process.env.REACT_APP_IS_SENTRY_ENABLED === 'true';
export const SENTRY_DSN = 'https://3a5ce157a1bb4719b4164becbbe7c485@o78773.ingest.sentry.io/5794058';
